import * as moment from 'moment';
import { DateRange } from '../../../projects/shared/src/lib/models/date-range.model';

export class RelevantExecutionsDateRangeCommand {
    start_date: string;
    end_date: string;

    constructor(query: DateRange) {
        if (moment.isMoment(query.startDate)) {
            this.start_date = query.startDate.format(); // Use format() directly
        } else {
            this.start_date = moment(query.startDate).format(); // Format startDate using moment.js
        }

        if (moment.isMoment(query.endDate)) {
            this.end_date = query.endDate.format(); // Use format() directly
        } else {
            this.end_date = moment(query.endDate).format(); // Format endDate using moment.js
        }
    }
}
